export enum FileUploadType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}
